export default () => {
  // Altering natives is frowned upon, but saves us a library/class and incompatibility w/ react-router.
  // eslint-disable-next-line
  String.prototype.format = function(...values) {
    return this.match(/:[aA-zZ]+/g).reduce(
      (acc, curr, i) => acc.replace(curr, values[i]),
      this
    )
  }
}



// WEBPACK FOOTER //
// ./src/helpers/paramFormatter.js